// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1764":"fdfd422b55092d76","5811":"e43597527c0ca687"}[chunkId] + ".js";
};